let recommendationData: any = null;

export function setRecommendationData(data: any): void {
    recommendationData = data;
}

export function getRecommendationData(): any {
    return recommendationData;
}

export function getRecommendationId(): string | null {
    return recommendationData?.id ?? null;
}